"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decimals = exports.tensBelowTwenty = exports.hundreds = exports.tens = exports.ordinalOnes = exports.ones = exports.convertDigitsToWordsDefaultOptions = void 0;
var convert_digits_to_words_1 = require("./convert-digits-to-words");
exports.convertDigitsToWordsDefaultOptions = {
    ordinal: false,
    throwErrorIfInvalid: false,
};
exports.ones = ['یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
exports.ordinalOnes = ['اول', 'دوم', 'سوم', 'چهارم', 'پنجم', 'ششم', 'هفتم', 'هشتم', 'نهم'];
exports.tens = ['بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
exports.hundreds = ['یکصد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
exports.tensBelowTwenty = [
    'ده',
    'یازده',
    'دوازده',
    'سیزده',
    'چهارده',
    'پانزده',
    'شانزده',
    'هفده',
    'هجده',
    'نوزده',
];
exports.decimals = ['دهم', 'صدم', 'هزارم', 'ده هزارم', 'صد هزارم', 'میلیونیم'];
exports.default = convert_digits_to_words_1.convertDigitsToWords;
